/** @jsxRuntime classic */
/** @jsxFrag React.Fragment */
/** @jsx jsx */
import { useCallback, useState } from 'react'
import { jsx } from '@emotion/core'
import { Card, GhostButton, H1, H4, Modal, PaginationBar, Row, TableRow, TableV2 } from '@bonitour/components'
import { useHistory } from 'react-router-dom'
import { useGetBraspagSchedule } from './hooks/useGetBraspagSchedule'
import { BraspagScheduleFilter } from './FIlter/BraspagScheduleFilter'
import { formatDate, formatMoney } from '@bonitour/common-functions'
import { TotalPriceDisplay } from 'Shared/components/TotalPriceDisplay/TotalPriceDisplay'
import { containerButton, headerTitleStyle, modalContainer, tableV2Container } from './BraspagSchedule.styles'
import { PER_PAGE } from './constants/braspagSchedule'

const TITLES = [
  'Data', 'Brand', 'Valor'
]

const PER_PAGE_OPTIONS = [PER_PAGE]

export const BraspagSchedule = () => {
  const { push } = useHistory()

  const goBack = useCallback(() => push('/dashboard'), [push])

  const [isVisible, setIsVisible] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)

  const onCloseModal = useCallback(() => setIsVisible(false), [])

  const handleRowClick = useCallback((item) => {
    setSelectedItem(item)
    setIsVisible(true)
  }, [])

  const {
    filters,
    handleFiltersChange,
    braspagScheduleData,
    pagination,
    loading,
    handleOnPageChange,
    totalPrice
  } = useGetBraspagSchedule()

  const {
    page,
    perPage,
    totalItems,
    totalPages
  } = pagination || {}

  const formatAuthorizationDate = useCallback((date) => {
    const [datePart, timePart] = date.split('T')
    return `${formatDate(datePart)} ${timePart}`
  }, [])

  const formatValue = useCallback((value) => {
    const newValue = (value || 0) / 100
    return newValue ? formatMoney(newValue) : 0
  }, [])

  return (
    <>
      <Row css={containerButton}>
        <H1 className='title'>Agenda Braspag</H1>
        <GhostButton onClick={goBack}>Voltar</GhostButton>
      </Row>

      <Card>
        <BraspagScheduleFilter
          handleFiltersChange={handleFiltersChange}
          filters={filters}
          loadingBraspagSchedule={loading}
        />

        <H4 css={headerTitleStyle}>Resultado da pesquisa</H4>
        <TotalPriceDisplay totalPrice={totalPrice}/>

        <TableV2
          isLoading={loading}
          labels={TITLES}
          mobileBreakpoint={1024}
          customCss={[tableV2Container]}
        >
          {
            braspagScheduleData?.map((item, index) => (
              <TableRow
                key={`${item?.id}-${index}`}
                onClick={() => handleRowClick(item)}
              >
                <>{formatDate(item?.forecastedDate)}</>
                <>{item?.brand}</>
                <p className={`${item?.forecastedNetAmount < 0 ? 'red' : 'green'}`}>
                  {formatValue(item?.forecastedNetAmount)}
                </p>
              </TableRow>
            ))
          }
        </TableV2>
        <PaginationBar
          currentPage={page}
          perPage={perPage}
          totalPages={totalPages}
          totalElements={totalItems}
          perPageOptions={PER_PAGE_OPTIONS}
          onPageChange={handleOnPageChange}
          onPerPageChange={() => null}
        />
      </Card>
      <Modal
        title='Detalhes da agenda'
        isVisible={isVisible}
        onCloseClick={onCloseModal}
        customCss={[]}
      >
        {selectedItem?.itemSchedules.map((schedule) => (
          <div key={schedule?.scheduleId} css={modalContainer}>
            {schedule?.paymentDetails?.authorizationDate && (
              <div>
                <p>Data de autorização:</p>
                <p>{formatAuthorizationDate(schedule.paymentDetails.authorizationDate)}</p>
              </div>
            )}

            {schedule?.installmentNetAmount && (
              <div>
                <p>Valor da parcela:</p>
                <p className={`${schedule.installmentNetAmount < 0 ? 'red' : 'green'}`}>
                  {formatValue(schedule.installmentNetAmount)}
                </p>
              </div>
            )}

            {(schedule?.installmentNumber != null || schedule?.paymentDetails?.installments != null) && (
              <div>
                <p>Parcelas:</p>
                <p>{schedule?.installmentNumber || 0}/{schedule?.paymentDetails?.installments || 0}</p>
              </div>
            )}

            {schedule?.scheduleType && (
              <div>
                <p>Tipo:</p>
                <p>{schedule.scheduleType}</p>
              </div>
            )}

            {schedule?.paymentDetails?.nsu && (
              <div>
                <p>DOC:</p>
                <p>{schedule.paymentDetails.nsu}</p>
              </div>
            )}
          </div>
        ))}
      </Modal>
    </>
  )
}
